import { Outlet } from 'react-router';
import PageLayout from '@/components/page-layout';

export const Users = () => {
	return (
		<PageLayout>
			<Outlet />
		</PageLayout>
	);
};
